/**
 * Trade-hub market — a rotating shop that re-rolls its stock every few minutes.
 * Each item has a chance to appear and a max stock; when it appears, its stock is
 * a random 1..maxStock. Bought with Universal Units.
 */
export interface MarketItemDef {
  id: string;
  name: string;
  icon: string;
  cost: number; // Universal Units
  chance: number; // probability to appear on a refresh
  maxStock: number;
}

export const MARKET_ITEMS: MarketItemDef[] = [
  { id: "moonCore", name: "Moon Core", icon: "◆", cost: 200, chance: 1, maxStock: 5 },
  { id: "energyCore", name: "Energy Core", icon: "⬢", cost: 700, chance: 0.25, maxStock: 2 },
  { id: "warpFuel", name: "Warp Drive Fuel", icon: "⛽", cost: 500, chance: 0.5, maxStock: 1 },
];

export const MARKET_REFRESH_SEC = 300; // 5 minutes

export interface MarketStock {
  id: string;
  name: string;
  icon: string;
  cost: number;
  stock: number;
}

export function rollMarket(): MarketStock[] {
  const out: MarketStock[] = [];
  for (const it of MARKET_ITEMS) {
    if (Math.random() < it.chance) {
      out.push({
        id: it.id,
        name: it.name,
        icon: it.icon,
        cost: it.cost,
        stock: 1 + Math.floor(Math.random() * it.maxStock),
      });
    }
  }
  return out;
}
